import { css } from '@emotion/react';
import { type FC } from 'react';
import type { Theme } from '~/_shared/themes/theme.model';
import { useTranslation } from '~/_shared/utils/hooks';

const noteStyle = (theme: Theme) => css({
  color: theme.textColors.contrast,
  fontWeight: 500,
  lineHeight: 1.5,
});

type DataSourceNotesProps = Readonly<{
  isNewSalesRepMap?: boolean;
}>;

export const DataSourceNotesComponent: FC<DataSourceNotesProps> = ({
  isNewSalesRepMap,
}) => {
  const [t] = useTranslation();

  return (
    <>
      {isNewSalesRepMap && (
        <strong css={noteStyle}>
          {t('spreadsheet.note.column.header.sales-map')}
          <br /><br />
        </strong>
      )}
      <strong css={noteStyle}>{t('spreadsheet.note.column.header')}</strong>
    </>
  );
};
